import React from 'react';

import { FiltersProvider } from 'context';

export const wrapPageElement = ({ element }) => (
  <FiltersProvider>{element}</FiltersProvider>
);
